import { formatDateToDDMMYYYY } from '../../modules/utils/formatters'
import { WORK_REGISTER_PAGE_SIZE } from '../../config/settings/constant'

const adapterRecord = item => ({
  categoryCode: item?.codCategoria ?? null,
  categoryDescription: item?.nombreCategoria ?? '',
  consultantRegistrationCode: item?.codTipoRegistro ?? '',
  consultantRegistrationDescription: item?.descripcionRegistro ?? '',
  expirationDate: formatDateToDDMMYYYY(item?.fechaCaducidad ?? ''),
  sectorCode: item?.codRubro ?? '',
  sectorDescription: item?.nombreRubro ?? '',
  specialtyCode: item?.codEspecialidad ?? '',
  specialtyDescription: item?.nombreEspecialidad ?? '',
  registrationState: item?.descripcionEstadoRegistro ?? 'No informado'
})

const adapterRecords = ins => ({
  content: ins?.content?.map(adapterRecord) ?? [],
  page: ins?.page ?? 1,
  size: ins?.size ?? WORK_REGISTER_PAGE_SIZE,
  totalElements: ins?.totalElements ?? 0,
  totalPages: ins?.totalPages ?? 0
})

const adapterRegistration = (reg, registerCode) => ({
  startDate: formatDateToDDMMYYYY(reg?.fechaInscripcion ?? ''),
  expirationDate: formatDateToDDMMYYYY(reg?.fechaCaducidadRegistro ?? ''),
  economicCapacity: reg?.capacidadEconomicaDetalle ?? '',
  registrationCode: String(reg?.codigoRegistro ?? registerCode),
  registrationDescription: reg?.descripcionEstadoRegistro ?? '',
  statusCode: reg?.codEstadoCapacidadEconomica ?? null,
  statusDescription: reg?.descripcionEstadoRegistro ?? '',
  providerState: reg?.estadoProveedorMOP ?? '',
  supplierRut: reg?.rutProveedor ?? ''
})

export const adapterMopResponse = (data, registerCode) => {
  if (!data || !data?.inscripciones || !data?.registro)
    return {
      records: [],
      registration: null
    }

  return {
    records: adapterRecords(data?.inscripciones),
    registration: adapterRegistration(data?.registro, registerCode)
  }
}
